import React from "react";

const PageSkeleton = () => {
  return (
    <div className="p-6 space-y-6">

      {/* Header Section */}
      <div className="space-y-3">
        <div className="h-7 w-1/3 rounded skeleton-shimmer"></div>
        <div className="h-4 w-1/4 rounded skeleton-shimmer"></div>
      </div>

      {/* Card Section */}
      <div className="bg-white rounded-xl shadow-sm p-6 space-y-4">
        <div className="h-4 w-full rounded skeleton-shimmer"></div>
        <div className="h-4 w-5/6 rounded skeleton-shimmer"></div>
        <div className="h-4 w-4/6 rounded skeleton-shimmer"></div>
      </div>

      {/* Table Section */}
      <div className="bg-white rounded-xl shadow-sm p-4 space-y-4">
        
        {/* Table Header */}
        <div className="grid grid-cols-4 gap-4">
          <div className="h-4 rounded skeleton-shimmer"></div>
          <div className="h-4 rounded skeleton-shimmer"></div>
          <div className="h-4 rounded skeleton-shimmer"></div>
          <div className="h-4 rounded skeleton-shimmer"></div>
        </div>

        {/* Table Rows */}
        {[1,2,3,4,5].map((_, i) => (
          <div key={i} className="grid grid-cols-4 gap-4">
            <div className="h-4 rounded skeleton-shimmer"></div>
            <div className="h-4 rounded skeleton-shimmer"></div>
            <div className="h-4 rounded skeleton-shimmer"></div>
            <div className="h-4 rounded skeleton-shimmer"></div>
          </div>
        ))}

      </div>

    </div>
  );
};

export default PageSkeleton;
